/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type AgentBadge_agent$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type JobEventBuildStepUploadCreated_event$ref: FragmentReference;
export type JobEventBuildStepUploadCreated_event = {|
  +timestamp: any,
  +actor: {|
    +node: ?{|
      +$fragmentRefs: AgentBadge_agent$ref
    |}
  |},
  +buildStepUpload?: {|
    +definition: {|
      +yaml: string
    |}
  |},
  +$refType: JobEventBuildStepUploadCreated_event$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "JobEventBuildStepUploadCreated_event",
  "type": "JobEvent",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "timestamp",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "actor",
      "storageKey": null,
      "args": null,
      "concreteType": "JobEventActor",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "AgentBadge_agent",
              "args": null
            }
          ]
        }
      ]
    },
    {
      "kind": "InlineFragment",
      "type": "JobEventBuildStepUploadCreated",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "buildStepUpload",
          "storageKey": null,
          "args": null,
          "concreteType": "BuildStepUpload",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "definition",
              "storageKey": null,
              "args": null,
              "concreteType": "BuildStepUploadDefinition",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "yaml",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '04b4d3825985d44468e22114ea9276c1';
module.exports = node;
